import type { ReactNode } from 'react';

interface SenderEmptyStateProps {
	message: string;
	action?: ReactNode;
}

export default function SenderEmptyState({ message, action }: SenderEmptyStateProps) {
	return (
		<div className='flex flex-col items-center gap-3 py-8 text-center'>
			<p className='text-[15px] text-muted-foreground'>{message}</p>
			{action}
		</div>
	);
}
